import { useAccountStore } from '~/stores/account'
import { useSettingsStore } from '~/stores/settings'
import type { TRoutes } from '~/types/routes'
import { extractTokenPayload } from '~/utils/extract-token-payload'

export const useRootRedirectTo = (): TRoutes | null => {
  const sourceLanguage = useSettingsStore(state => state.sourceLanguage)
  const learnLanguage = useSettingsStore(state => state.learnLanguage)
  const accountId = useAccountStore(state => state.id)
  const jwtPayload = extractTokenPayload()

  if (!accountId || !jwtPayload) return '/auth/login'

  if (jwtPayload.subscriptionStatus !== 'ACTIVE') return '/subscription'

  const isNoLanguages = !sourceLanguage?.value || !learnLanguage?.value

  return isNoLanguages ? '/onboard' : null
}
